module.exports = __webpack_public_path__ + "static/media/img-02.09fa3c70.jpg";